import { breakpoints } from '@toggle/design-system';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 12px;
  flex-grow: 1;
  background-color: var(--surface-default);

  @media ${breakpoints.lg} {
    height: 320px;
    margin-top: 0px;
  }

  @media ${breakpoints.lg} and (max-height: 880px) {
    height: 230px;
  }
`;
